$(".pianta-popup__trigger").on("click", function(e) {
  e.preventDefault();
  console.log('trigger');

  const title = $(this)
    .data("title");

  const image = $(this)
    .data("image");

  const content = $(this)
    .data("content");

  $(".o-popup--pianta")
    .find(".o-pianta-popup__title")
    .text(title);

  $(".o-popup--pianta")
    .find(".o-pianta-popup__image")
    .html(image);

  $(".o-popup--pianta")
    .find(".o-pianta-popup__content")
    .html(content);

  $(".backplate").addClass("backplate--open");
  $(".o-popup--pianta").addClass("o-popup--open");
});

$(".backplate,.o-popup__close").on("click", function() {
  $(".o-popup--pianta").removeClass("o-popup--open");
  $(".backplate").removeClass("backplate--open");
});